import {z} from 'zod'

import {EngagementRowSchema} from './common'

export const AssignedUnassignedDataSchema = z
    .object({
        assigned: z.array(EngagementRowSchema),
        unassigned: z.array(EngagementRowSchema),
        total_assigned: z.number(),
        total_unassigned: z.number(),
    })
    .transform(({assigned, unassigned, total_assigned, total_unassigned}) => ({
        assigned,
        unassigned,
        totalAssigned: total_assigned,
        totalUnassigned: total_unassigned,
    }))

export type AssignedUnassignedData = z.infer<typeof AssignedUnassignedDataSchema>
